/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Teams_Delete_Button_LabelInputs */



/**
* | output |
* | --- |
* | "Delete team {name}" |
*
* @param {Teams_Delete_Button_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teams_delete_button_label = /** @type {((inputs: Teams_Delete_Button_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_Delete_Button_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Team "${i?.name}" löschen`)
	return /** @type {LocalizedString} */ (`Delete team ${i?.name}`)
});